import { configurationTypes } from '@/configuration/pages/ConfigurationPage/constants'
import configurationServices from '@/configuration/services/services'

export const servicesByConfigurationMode = {
  [configurationTypes.merchant]: {
    getPreviewEmailTemplate: configurationServices.getMerchantPreviewEmailTemplate,
  },
  [configurationTypes.returnsPortal]: {
    getPreviewEmailTemplate: configurationServices.getPortalPreviewEmailTemplate,
  },
}
